import React, {useState, useImperativeHandle, forwardRef} from 'react';
import { meFn } from '../../lib/api';
import { Spinner } from '../Spinner';
import { setCookie } from '../../lib/utils';
import './FormatSelectionWithVideo.scss';


const FormatSelectionWithVideo = ({settings, settingsCallback}) => {

    const [format, setFormat] = useState(settings && settings.videoFormat?settings.videoFormat:null);

    const [preferredBackground, setPreferredBackground] = useState(settings && settings.preferredBackground?settings.preferredBackground:null);

    const [loading, setLoading] = useState(false);

    const selectOption = async (data) => {
        setLoading(true);
        
        if(data.videoFormat){
            setFormat(data.videoFormat);
            //Set dpref to both localStorage and cookie
            //DEPRACATED LOCALSTORAGE
            //localStorage.setItem('dpref', data.videoFormat);
            setCookie('dpref', data.videoFormat, 365);
        }
        if(data.preferredBackground){
            setPreferredBackground(data.preferredBackground);
        }
        
        await meFn(data);
        await settingsCallback();
        setLoading(false);

    };

    return (
        <div className="format-selection m-h-a row-section">
            <div className="title ">Format Preference</div>
            {loading && 
            <div className={`loading visible`}>
                Saving...
            </div>
            }
            <div className="list m-r-a">
                <div className={`item ${format==='mov'?'selected':''}`} onClick={() => selectOption({videoFormat: 'mov'})}>
                    <div className="name m-b-12">PNG Codec <span class="note">(.MOV)</span></div>
                    <video width="100%" className="m-b-12" autoPlay muted loop>
                        <source src="https://public.productioncrate.com/videos/product_pages/homepages/footagecrate/FootageCrate_Homepage_Formats_ProRes.mp4" type="video/mp4"/>
                        Your browser does not support the video tag.
                    </video>
                    <div className="subtitle m-b-10">Best for Compatibility</div>
                    <div className="description m-b-16">
                    This format uses the PNG codec inside a .MOV container to preserve alpha transparency and high image quality. Great for use in a wide range of editing software with good balance between quality and file size.
                    </div>
                </div>
                <div className={`item ${format==='mp4'?'selected':''}`} onClick={() => selectOption({videoFormat: 'mp4'})}>
                    <div className="name m-b-12">MP4</div>
                    <video className="m-b-12" width="100%" autoPlay muted loop>
                    <source src="https://public.productioncrate.com/videos/product_pages/homepages/footagecrate/FootageCrate_Homepage_Formats_MP4.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                    </video>
                    <div className="subtitle m-b-10">Best for Speed</div>
                    <div className="description m-b-16">
                    This format includes a green, blue or black background for keying and blending in your editing software. Ideal for quick solutions, small files and mobile devices.
                    </div>
                </div>
                <div className={`item ${format==='prores'?'selected':''}`} onClick={() => selectOption({videoFormat: 'prores'})}>
                    <div className="name m-b-12">ProRes <span class="note">(.MOV)</span></div>
                    <video width="100%" className="m-b-12" autoPlay muted loop>
                        <source src="https://public.productioncrate.com/videos/product_pages/homepages/footagecrate/FootageCrate_Homepage_Formats_ProRes.mp4" type="video/mp4"/>
                        Your browser does not support the video tag.
                    </video>
                    <div className="subtitle m-b-10">Best for Quality</div>
                    <div className="description m-b-16">
                    This format includes a pre-keyed transparent alpha background. Ideal for color fidelity and efficiency at the cost of larger file sizes.
                    </div>
                </div>
                <div className={`item ${format==='seq'?'selected':''}`} onClick={() => selectOption({videoFormat: 'seq'})}>
                    <div className="name m-b-12">PNG Sequence (.ZIP)</div>
                    <img src="https://public.productioncrate.com/videos/product_pages/homepages/footagecrate/pngsequence.jpg" className="pic m-b-12" />
                    <div className="subtitle m-b-10">Best for Frame-by-Frame Control</div>
                    <div className="description m-b-16">
                    This format provides each frame as a separate PNG image with transparency, zipped for download. Ideal for precise editing, custom frame timing, and integration into non-linear workflows or game engines.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormatSelectionWithVideo;

